import { useEffect, useState } from "react";
import axios from "axios";
import { NumberCounter } from "../number-counter";
import { COLORS } from "../../styles";
import styled from "styled-components";
import { Box } from "@vinomofo/components";

interface SubscriberCountResponse {
  count: number;
  timeAgo: string;
  updatedAt: string;
  isRecent: boolean;
  name?: string;
}

const SectionHeader = styled(Box)`
  text-align: center;
  margin-bottom: 50px;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.5s ease forwards;

  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const SubLabel = styled(Box)<{ color?: string }>`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 14px;
  color: ${({ color }) => color || COLORS.white};
  opacity: 0.7;
  text-align: center;
  margin-top: 10px;
`;

export const SubscriberCount = () => {
  const [
    subscriberCount,
    setSubscriberCount,
  ] = useState<SubscriberCountResponse | null>(null);

  useEffect(() => {
    const fetchSubscriberCount = async () => {
      try {
        const response = await axios.get<SubscriberCountResponse>(
          "/api/get-subscriber-count"
        );
        setSubscriberCount(response.data);
      } catch (error) {
        console.error("Error fetching subscriber count:", error);
      }
    };

    fetchSubscriberCount();
  }, []);

  if (!subscriberCount?.count || subscriberCount.count <= 0) {
    return null;
  }

  return (
    <SectionHeader>
      <NumberCounter
        targetNumber={subscriberCount?.count || 0}
        label="Members & Counting"
      />
      <SubLabel>
        WHISKYMOFO MEMBER #{subscriberCount?.count?.toLocaleString() || 0}
      </SubLabel>
      {subscriberCount?.isRecent && (
        <>
          <SubLabel>JUST SIGNED UP</SubLabel>
          <SubLabel color={COLORS.liquidGold}>
            {subscriberCount?.timeAgo.toUpperCase() || ""}
          </SubLabel>
        </>
      )}
    </SectionHeader>
  );
};
